import { CheckRounded } from '@mui/icons-material';
import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import { StatusBadge, createFocusRingStyles, designTokens } from '../../../design-system';
import type { SetupTask } from '../model/setup';

export function SetupTaskButton({
  task,
  index,
  active,
  complete,
  locked,
  detail,
  disabled,
  onClick,
}: {
  task: SetupTask;
  index: number;
  active: boolean;
  complete: boolean;
  locked: boolean;
  detail: string;
  disabled: boolean;
  onClick: () => void;
}) {
  const status = complete ? '완료' : active ? '현재' : locked ? '대기' : '입력 필요';
  return (
    <ButtonBase
      data-testid={`setup-task-${task.id}`}
      aria-current={active ? 'step' : undefined}
      disabled={disabled}
      onClick={onClick}
      sx={{
        width: '100%', minWidth: 0, minHeight: 62, px: 2, py: 1.25,
        justifyContent: 'flex-start', textAlign: 'left', borderRadius: 0,
        borderBottom: `1px solid ${designTokens.color.divider}`,
        bgcolor: active ? designTokens.color.canvas : 'transparent',
        '&:hover': { bgcolor: active ? designTokens.color.canvas : designTokens.color.hoverSurface },
        '&:focus-visible': createFocusRingStyles({ inset: true }),
        '&.Mui-disabled': { opacity: 1 },
      }}
    >
      <Box sx={{ width: 24, height: 24, mr: 1.25, borderRadius: '50%', display: 'grid', placeItems: 'center', flex: '0 0 auto', border: '1px solid', borderColor: complete ? designTokens.color.success : active ? designTokens.color.action : designTokens.color.strongDivider, bgcolor: complete ? designTokens.color.success : designTokens.color.canvas, color: complete ? designTokens.color.canvas : active ? designTokens.color.action : designTokens.color.secondaryText }}>
        {complete ? <CheckRounded sx={{ fontSize: 16 }} /> : <Typography component="span" variant="caption" sx={{ lineHeight: 1, fontWeight: 750 }}>{index + 1}</Typography>}
      </Box>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'baseline', justifyContent: 'space-between' }}>
          <Typography variant="body2" sx={{ fontWeight: active ? 750 : 650, color: locked ? designTokens.color.disabledText : designTokens.color.primaryText }}>{task.title}</Typography>
          <StatusBadge label={status} tone={complete ? 'success' : active ? 'info' : locked ? 'neutral' : 'warning'} />
        </Stack>
        <Typography variant="caption" color={locked ? designTokens.color.disabledText : 'text.secondary'} sx={{ display: 'block', mt: 0.3, overflowWrap: 'anywhere' }}>{detail}</Typography>
      </Box>
    </ButtonBase>
  );
}
